<template>
<div class="chapter">
<div class="inner_page">
<section class="dedication" epub:type="dedication">
<p>For my dear husband, James.</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter1.vue?33bdbc52